export const msalConfig = {
    auth: {
      clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID,
      authority: 'https://login.microsoftonline.com/consumers',
      redirectUri: process.env.REACT_APP_MICROSOFT_REDIRECT_URL, // Replace with your redirect URI
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
    system: {
      allowRedirectInIframe: true,
      asyncPopups: true,
      iframeHashTimeout: 6000000
    },
    framework: {
      responseType: 'code',
    },
  };
  
  